import { IApplicationState } from '../../types/redux';
import { ETab } from '../../types/tab';

export const getActiveTab = (state: IApplicationState): ETab => {
  return state.tabs;
};
